import { render, staticRenderFns } from "./TheToolsLayout.vue?vue&type=template&id=35d599c2"
import script from "./TheToolsLayout.vue?vue&type=script&lang=js"
export * from "./TheToolsLayout.vue?vue&type=script&lang=js"
import style0 from "./TheToolsLayout.vue?vue&type=style&index=0&id=35d599c2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports